<div fxLayout="column">
  <div *ngIf="loading" fxLayoutAlign="center">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <div fxLayout="row" style="margin-left: 10px; font-size: 1.1em">
    <a (click)="showDashboard()">< Back to Dashboard</a>
  </div>
  <div class="tile-container" fxLayout="column" fxFlex="80%">
    <div fxLayout="row" class="tile-header">
      Increased Session Lift in Micro-moment
    </div>
    <div fxLayout="row" class="primary-color average-lift" fxLayoutAlign="center">{{ averageLift }}%</div>
    <div class="descr" fxLayout="row wrap" fxFlex="40%" fxFlexAlign="center">
      Average lift to web traffic in the five minute micro-moment compared to five minute window before the
      micro-moment.
    </div>
    <mat-divider></mat-divider>
    <div fxLayout="row wrap" fxLayoutAlign="center" class="list">
      <div
        class="spot"
        fxLayout="column"
        fxFlex="32%"
        fxLayoutGap="2%"
        *ngFor="let spot of spots; let i = index"
        [ngClass]="{ 'right-divider': needsDivider(i), 'left-divider': lastRecord(i) }"
      >
        <div class="isci">{{ spot.isci }}</div>
        <div class="lift primary-color">{{ getLiftText(spot.avgPctLift) }}</div>
        <div>Airings: {{ spot.airingCount }}</div>
        <div>Total 5 minutes before airing: {{ spot.avgBaseline }}</div>
        <div>Total 5 minutes during Micro-moment: {{ spot.avgSessions }}</div>
        <div>{{ getAffiliateText(spot) }}</div>
      </div>
    </div>
  </div>
</div>
